import { createContext, useContext, useEffect, useState } from 'react';
import { useIsFetching } from '@tanstack/react-query';
import { DEFAULT_QUIZ_WORKSHEET_IMAGE_QUERY_KEY } from '../QuizWorksheetImage';
type LoadingWorksheetPreviewContextType = {
  isLoading: boolean;
};
const loadingWorksheetPreviewContext = createContext<LoadingWorksheetPreviewContextType>({
  isLoading: true
});
export const LoadingWorksheetPreviewContext = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const isFetching = useIsFetching({
    predicate: query => {
      return query.queryKey.includes(DEFAULT_QUIZ_WORKSHEET_IMAGE_QUERY_KEY) && query.state.status === 'pending';
    }
  });
  useEffect(() => {
    if (isFetching === 0) {
      const timer = setTimeout(() => setIsLoading(false), 100);
      return () => clearTimeout(timer);
    }
  }, [isFetching]);
  return <loadingWorksheetPreviewContext.Provider value={{
    isLoading
  }} data-sentry-element="unknown" data-sentry-component="LoadingWorksheetPreviewContext" data-sentry-source-file="LoadingWorksheetPreviewContext.tsx">
      {children}
    </loadingWorksheetPreviewContext.Provider>;
};
export const useLoadingWorksheetPreviewContext = () => {
  const context = useContext(loadingWorksheetPreviewContext);
  if (!context) {
    throw new Error('LoadingWorksheetPreviewContext not found');
  }
  return context;
};